module.exports = __webpack_public_path__ + "static/Telemedicine-c78bb5f7e8dc884d3f1bf7224c0ec254.svg";